import * as React from 'react'

import { observer } from 'mobx-react'

import FormComponent from 'modules/core/components/Form'
import PanesHeader from 'modules/core/components/PanesHeader'
import PanesPadForm from 'modules/core/components/PanesPadForm'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { employeeLegalEntity } from 'modules/core/lib/employeeLegalEntity'
import { formGetDirtyFields } from 'modules/core/lib/formGetDirtyFields'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import {
  FormTypes,
  useEmployeePersonalProvider,
} from 'modules/employees/components/blocks/EmployeePersonalProvider'
import type Employee from 'modules/employees/store/models/Employee'

import Fields from './Fields'

interface Props {
  employee: Employee
  readonly?: boolean
  payroll: boolean
  legalEntity: LegalEntity | null
}

export const GeneralBlock = observer((props: Props) => {
  const {
    userForm,
    generalForm,
    disableSectionSaveButtons,
    onSubmit: onSubmitGeneral,
  } = useEmployeePersonalProvider()

  const { employee, readonly, payroll, legalEntity } = props

  const onSubmit = () => {
    track(trackingEvents.employee.editEmployeeInformationSubmit, {
      fields_edited: [...formGetDirtyFields(generalForm), ...formGetDirtyFields(userForm)],
      legal_entity_country: employeeLegalEntity(employee).country,
      layout_version: 'v1',
    })
    onSubmitGeneral([FormTypes.GENERAL, FormTypes.USER])
  }

  return (
    <>
      <FormComponent onSubmit={onSubmit}>
        <Fields
          employee={employee}
          readonly={readonly}
          payroll={payroll}
          userForm={userForm}
          generalForm={generalForm}
          legalEntity={legalEntity}
          disableSectionSaveButtons={disableSectionSaveButtons}
        />
      </FormComponent>
    </>
  )
})

const General = (props: Props) => {
  return (
    <PanesPadForm direction="horizontal" boxed>
      <PanesHeader
        illustration="user"
        title={i18n.t('employee_form.general_information.title')}
        description={i18n.tCurrent(
          'employee_form.general_information.description',
          employeeUser(props.employee).isCurrent()
        )}
      />
      <GeneralBlock {...props} />
    </PanesPadForm>
  )
}

export default observer(General)
